import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Pagination from "../../components/shared/Pagination"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import InputSelectLoadListFilter from "../../components/shared/input/special/InputSelectLoadListFilter"
import ItemContainer from "../../components/topList/yuklemedeList/item/ItemContainer"
import ItemContainerWide from "../../components/topList/yuklemedeList/item/ItemContainerWide"
import ItemMobileContainer from "../../components/topList/yuklemedeList/item/ItemMobileContainer"
import YuklemeListTopContainer from "../../components/topPages/topContainer/YuklemeListTopContainer"
import TopPagesMap from "../../components/topPagesMap/TopPagesMap"
import CollapsibleTopMap from "../../components/topPages/CollapsibleTopMap"
import ShipmentBulkActions from "../../components/topPages/ShipmentBulkActions"
import usePageShipmentSelection from "../../hooks/usePageShipmentSelection"
import useWindowDimensions from "../../hooks/useWindowSize"
import { getAdminCompanyLoadFilter, resetSingleShipmentLoadItem, setCompleteShipmentIds } from "../../features/loadList/loadListSlice"
import { resetAllState } from "../../features/topPagesMap/topPagesMapSlice"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      gap: 60px;
      margin: 20px 30px 0;

      .top-filter-admin {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        width: 100%;
        margin-block: 20px;
      }

      .loading {
        min-height: 30vh;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pagination-container {
      gap: 60px;
      margin: 20px 30px 0;
      height: 200px;
    }
  }
`

const AtananlarList = () => {
  const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage
  const rld = JSON.parse(storage.getItem("rld"))
  const dispatch = useDispatch()
  const {windowDimensions} = useWindowDimensions()
  const {
    atananlarList,
    atananlarListQuantity,
    isLoadingAtananlarList,
    loadItemSelect,
    selectedLoadListCompany,
    loadListCompanyList
  } = useSelector(state => state.loadList)

  const [activeItemId, setActiveItemId] = useState(null)
  const [isMapOpen, setIsMapOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const {
    selectedShipmentIds,
    toggleShipment,
    selectAllOnPage,
    clearSelection,
    allPageSelected
  } = usePageShipmentSelection(atananlarList)

  const itemsPerPage = 20
  const totalPages = Math.ceil((atananlarListQuantity ?? 0) / itemsPerPage)

  const openCompletePermission = () => {
    dispatch(setCompleteShipmentIds(selectedShipmentIds))
    dispatch(showModal("completeShipmentsPermission"))
  }

  useEffect(() => {
    const matchedItem = atananlarList.find(item => item.waitinLoadId === loadItemSelect)
    if (!matchedItem) {
      window.scrollTo(0, 0)
      return
    }

    const element = document.getElementById(matchedItem.id)
    if (element) {
      const navbarHeight = 255
      const elementPosition = element.getBoundingClientRect().top + window.scrollY
      window.scrollTo({top: elementPosition - navbarHeight, behavior: "smooth"})
    }
  }, [loadItemSelect, atananlarList])

  useEffect(() => {
    if (rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99") {
      dispatch(getAdminCompanyLoadFilter())
    }
  }, [dispatch, rld])

  useEffect(() => () => {
    dispatch(resetAllState())
    dispatch(resetSingleShipmentLoadItem())
  }, [dispatch])

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title="Atananlar" position="sticky" />
        <div className="content">
          <CollapsibleTopMap isOpen={isMapOpen} onToggle={() => setIsMapOpen(open => !open)}>
            <TopPagesMap />
          </CollapsibleTopMap>

          {rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" && (
            <div className="top-filter-admin">
              <InputSelectLoadListFilter
                data={selectedLoadListCompany}
                labelText="Firma Adı"
                inputWidth="300px"
                initialOptions={loadListCompanyList}
                name="selectedLoadListCompany"
              />
            </div>
          )}

          <YuklemeListTopContainer currentPage={currentPage} listType="atananlar" />

          {selectedShipmentIds.length > 0 && (
            <ShipmentBulkActions
              selectedCount={selectedShipmentIds.length}
              allPageSelected={allPageSelected}
              onClear={clearSelection}
              onSelectAll={selectAllOnPage}
              onComplete={openCompletePermission}
            />
          )}

          {isLoadingAtananlarList ? (
            <div className="loading">
              <SmallSpinner size="65px" color="#fff" bgColor="#E85446" />
            </div>
          ) : (
            atananlarList.map((item) => {
              const width = windowDimensions?.width
              const isActive = item.id === activeItemId
              const ItemComponent = width < 850
                ? ItemMobileContainer
                : width < 1150 || isActive
                  ? ItemContainerWide
                  : ItemContainer

              return (
                <ItemComponent
                  key={item.id}
                  item={item}
                  setActiveItemId={setActiveItemId}
                  activeItemId={activeItemId}
                  isSelected={selectedShipmentIds.includes(item.id)}
                  onSelectionChange={toggleShipment}
                  onShowMap={() => setIsMapOpen(true)}
                  notificationType={2}
                  notificationStageType="atananlar"
                  statusText="Atanan"
                  detailPageTitle="Atanan Sevkiyat Detayı"
                />
              )
            })
          )}
        </div>

        <div className="pagination-container">
          {atananlarList.length > 0 && (
            <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage} />
          )}
        </div>
      </div>
    </Container>
  )
}

export default AtananlarList
